import React from "react";
import TypingHeading from "./heading/TypingHeading";
import { motion } from "framer-motion";

const SummarySkills = () => {
  return (
    // <motion.div
    //   initial={{ x: 200, opacity: 0 }}
    //   animate={{ x: 0, opacity: 1 }}
    //   transition={{ duration: 1, ease: "easeOut" }}
    //   className="bg-white/70 backdrop-blur-md rounded-xl shadow-lg p-8 md:p-10 w-full"
    // >
    <div>

       <motion.div
      initial={{ y: -200, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, ease: "easeOut" , delay: 0 }}>
      <TypingHeading />
      </motion.div>

      <motion.div
      initial={{ x: 200, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      transition={{ duration: 1, ease: "easeOut" , delay: 0 }}>
      <p className="text-xl font-medium leading-8 text-gray-800 mb-6 text-justify">
        I am a Java Full Stack Developer with over 2 years of hands-on experience in building and deploying scalable web applications. My core expertise lies in Java, Spring Boot, and microservices architecture on the backend, coupled with React for responsive and interactive frontend development. I have strong proficiency in working with AWS cloud services, enabling seamless integration, deployment, and scalability of applications in cloud environments.
      </p>
      </motion.div>

<motion.div
      initial={{ x: 200, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      transition={{ duration: 1, ease: "easeOut" , delay: 1.5 }}>
      <p className="text-xl font-medium leading-8 text-gray-800 mb-6 text-justify">
        In addition to full-stack development, I have also worked on developing and integrating Generative AI models, enhancing application intelligence and automation. I have independently designed and delivered multiple real-world projects from scratch, handling everything from architecture and development to deployment and maintenance. With a solid foundation in both backend and frontend technologies, along with cloud and AI capabilities, I bring a well-rounded, results-driven approach to software development.
      </p>
      </motion.div>

      <motion.div
      initial={{ x: 200, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      transition={{ duration: 1, ease: "easeOut" , delay: 2.25 }}>
      <p className="text-xl font-medium leading-8 text-gray-800 mb-6 text-justify">
        Outside of work, I enjoy watching movies and web series, which help me relax and stay creatively inspired. I’m also passionate about bike riding and traveling, as they give me a sense of freedom, adventure, and a chance to explore new places and cultures.
      </p>

    </motion.div> 
    </div>
  );
};

export default SummarySkills;
